import { range } from './collections';

export const randomBool = () => Math.random() >= 0.5;

export const randomInt: {
    (max?: number): number;
    (min: number, max: number): number;
} = (min = 100000000, max?: number) => {
    if (max == null) {
        max = min;
        min = 0;
    }

    return min + Math.round(Math.random() * (max - min));
};

export const randomEntry: {
    <TEntry>(collection: TEntry[]): TEntry;
    (str: string): string;
} = <TEntry>(collection: TEntry[] | string) =>
    collection && collection[randomInt(collection.length - 1)];

const randomStrChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const randomStr: {
    (length?: number): string;
    (minLength: number, maxLength: number): string;
} = (minLength = 10, maxLength: number = minLength) => {
    let text = '';

    for (let i = 0; i < randomInt(minLength, maxLength); i++) {
        text += randomEntry(randomStrChars);
    }

    return text;
};

export const randomText: {
    (words?: number): string;
    (minWords: number, maxWords: number): string;
    (minWords: number, maxWords: number, wordLength: number): string;
    (minWords: number, maxWords: number, minWordLength: number, maxWordLength: number): string;
} = (minWords = 5, maxWords = minWords, minWordLength = 10, maxWordLength = minWordLength) =>
    range(randomInt(minWords, maxWords))
        .map(() => randomStr(minWordLength, maxWordLength))
        .join(' ');

export const randomPhoneNumber = () => {
    return '+x-xxx-xxx-xxxx'.replace(/x/g, () => randomInt(9).toString());
};

export const randomUuid = () => {
    return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, () => randomInt(15).toString(16));
};

export const typedRandomUuuid = (type: string) => `[${type}]${randomUuid()}`;
